import { Button } from '@shared/components/shadcn';
import { Verified } from '@shared/icons/system';
import { useTranslations } from 'next-intl';
import { ReKycStepFooter, ReKycStepHeader } from '../../common';

function UpdatedConfirmationStep() {
  const t = useTranslations('my_account.rekyc');

  return (
    <>
      <ReKycStepHeader
        headerIcon={<Verified size="extra-extra-large" data-testid="rekyc-updated-confirmation-icon" />}
        title={t('updated_step.title')}
        description={t('updated_step.description')}
      />
      <ReKycStepFooter
        actions={
          <Button type="button" variant="primary" onClick={() => window.location.reload()} data-track-name="Continue" data-testid="rekyc-updated-continue-button">
            {t('updated_step.continue')}
          </Button>
        }
      />
    </>
  );
}

export { UpdatedConfirmationStep };
